import * as i0 from '@angular/core';
import { InjectionToken, Injectable, Optional, Inject, NgModule, SkipSelf } from '@angular/core';
import { toHttpParams, snakeCase, toCamelcase, createNamedApi, combineEffectsWithProviders } from '@essent/common';
export { FinancialItemType, PaymentMethod } from '@essent/common';
import * as i1$1 from '@ngrx/effects';
import { EffectsModule } from '@ngrx/effects';
import * as i1 from '@angular/common/http';

const API = new InjectionToken('api-payment');

class VerifyDeferralService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/payment/financialitems/verifydeferral/v${this.apiVersion}`;
    }
    call$({ invoices, ...inputParams }) {
        const headers = { Accept: 'application/json' };
        const params = toHttpParams(snakeCase(inputParams));
        return this.httpClient
            .put(this.endpoint, invoices, {
            params,
            headers
        })
            .pipe(toCamelcase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: VerifyDeferralService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: VerifyDeferralService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: VerifyDeferralService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const verifyDeferralApi = createNamedApi('[PaymentState] Verify deferral', VerifyDeferralService);

const containsMessage = (response, code) => (response?.error?.errors || []).find((error) => error.code === code) !== undefined;

var MessageCode;
(function (MessageCode) {
    MessageCode["SOLD_ITEMS"] = "1041";
    MessageCode["DEFERRAL_DOES_NOT_EXIST"] = "1023";
    MessageCode["INVOICE_WITH_P2P"] = "3001";
})(MessageCode || (MessageCode = {}));

class CreateDeferralService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/payment/financialitems/deferinvoice/v${this.apiVersion}`;
    }
    call$({ accountId, contractGroupId, contactLogId, ...payload }) {
        const headers = { Accept: 'application/json' };
        const params = toHttpParams(snakeCase({ accountId, contractGroupId, contactLogId }));
        const body = snakeCase(payload);
        return this.httpClient.post(this.endpoint, body, { params, headers });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: CreateDeferralService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: CreateDeferralService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: CreateDeferralService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const createDeferralApi = createNamedApi('[PaymentState] Create deferral', CreateDeferralService);

class GetPaymentsService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '3';
        this.endpoint = `${this.apiUrl || ''}/payment/payments/v${this.apiVersion}`;
    }
    call$(httpParams) {
        const headers = { Accept: 'application/json' };
        const params = toHttpParams(snakeCase(httpParams));
        return this.httpClient
            .get(this.endpoint, {
            params,
            headers
        })
            .pipe(toCamelcase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetPaymentsService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetPaymentsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetPaymentsService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const getPaymentsApi = createNamedApi('[PaymentState] Get payments', GetPaymentsService);

class IdealPaymentService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/payment/idealpayment/v${this.apiVersion}`;
    }
    call$({ accountId, contractGroupId, ...payload }) {
        const headers = { Accept: 'application/json' };
        const params = toHttpParams(snakeCase({ accountId, contractGroupId }));
        const body = snakeCase(payload);
        return this.httpClient
            .post(this.endpoint, body, { params, headers })
            .pipe(toCamelcase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: IdealPaymentService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: IdealPaymentService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: IdealPaymentService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const idealPaymentApi = createNamedApi('[PaymentState] Ideal payment', IdealPaymentService);

class CreateReimbursementsService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/payment/reimbursements/v${this.apiVersion}`;
    }
    call$({ accountId, contactlogId, ...payload }) {
        const headers = { Accept: 'application/json' };
        const body = snakeCase(payload);
        const params = toHttpParams(snakeCase({ accountId, contactlogId }));
        return this.httpClient.post(this.endpoint, body, { headers, params });
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: CreateReimbursementsService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: CreateReimbursementsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: CreateReimbursementsService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const createReimbursementsApi = createNamedApi('[PaymentState] Create reimbursements', CreateReimbursementsService);

class GetReimbursementsService {
    constructor(apiUrl, httpClient) {
        this.apiUrl = apiUrl;
        this.httpClient = httpClient;
        this.apiVersion = '1';
        this.endpoint = `${this.apiUrl || ''}/payment/reimbursements/v${this.apiVersion}`;
    }
    call$(httpParams) {
        const headers = { Accept: 'application/json' };
        const params = toHttpParams(snakeCase(httpParams));
        return this.httpClient
            .get(this.endpoint, {
            params,
            headers
        })
            .pipe(toCamelcase());
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetReimbursementsService, deps: [{ token: API, optional: true }, { token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetReimbursementsService }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: GetReimbursementsService, decorators: [{
            type: Injectable
        }], ctorParameters: () => [{ type: undefined, decorators: [{
                    type: Optional
                }, {
                    type: Inject,
                    args: [API]
                }] }, { type: i1.HttpClient }] });

const getReimbursementsApi = createNamedApi('[PaymentState] Get reimbursements', GetReimbursementsService);

const { EFFECTS, PROVIDERS } = combineEffectsWithProviders(getPaymentsApi, getReimbursementsApi, createReimbursementsApi, createDeferralApi, verifyDeferralApi, idealPaymentApi);
class PaymentCoreModule {
    constructor(parentModule) {
        if (parentModule) {
            throw new Error('PaymentCoreModule is imported more than once.');
        }
    }
    static forRoot(config) {
        return {
            ngModule: PaymentCoreModule,
            providers: [
                {
                    provide: API,
                    useValue: config ? config.api : undefined
                }
            ]
        };
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: PaymentCoreModule, deps: [{ token: PaymentCoreModule, optional: true, skipSelf: true }], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.2.7", ngImport: i0, type: PaymentCoreModule, imports: [i1$1.EffectsFeatureModule] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: PaymentCoreModule, providers: PROVIDERS, imports: [EffectsModule.forFeature(EFFECTS)] }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.2.7", ngImport: i0, type: PaymentCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [EffectsModule.forFeature(EFFECTS)],
                    providers: PROVIDERS
                }]
        }], ctorParameters: () => [{ type: PaymentCoreModule, decorators: [{
                    type: Optional
                }, {
                    type: SkipSelf
                }] }] });

const { getPaymentsActions, getPayments, getPaymentsSuccess, getPaymentsError, getPaymentsClear } = getPaymentsApi;

var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["IN_PROGRESS"] = "in_progress";
    PaymentStatus["CLEARED"] = "cleared";
})(PaymentStatus || (PaymentStatus = {}));

const { idealPaymentActions, idealPayment, idealPaymentSuccess, idealPaymentError, idealPaymentClear } = idealPaymentApi;

var Language;
(function (Language) {
    Language["EN"] = "en";
    Language["NL"] = "nl";
    Language["ES"] = "es";
    Language["DE"] = "de";
    Language["HU"] = "hu";
    Language["PL"] = "pl";
    Language["RO"] = "ro";
})(Language || (Language = {}));

const { createReimbursementsActions, createReimbursements, createReimbursementsSuccess, createReimbursementsError, createReimbursementsClear } = createReimbursementsApi;

const { getReimbursementsActions, getReimbursements, getReimbursementsSuccess, getReimbursementsError, getReimbursementsClear } = getReimbursementsApi;

const { verifyDeferralActions, verifyDeferral, verifyDeferralSuccess, verifyDeferralError, verifyDeferralClear } = verifyDeferralApi;

const { createDeferralActions, createDeferral, createDeferralSuccess, createDeferralError, createDeferralClear } = createDeferralApi;

/**
 * Generated bundle index. Do not edit.
 */

export { API, Language, MessageCode, PaymentCoreModule, PaymentStatus, containsMessage, createDeferral, createDeferralActions, createDeferralClear, createDeferralError, createDeferralSuccess, createReimbursements, createReimbursementsActions, createReimbursementsClear, createReimbursementsError, createReimbursementsSuccess, getPayments, getPaymentsActions, getPaymentsClear, getPaymentsError, getPaymentsSuccess, getReimbursements, getReimbursementsActions, getReimbursementsClear, getReimbursementsError, getReimbursementsSuccess, idealPayment, idealPaymentActions, idealPaymentClear, idealPaymentError, idealPaymentSuccess, verifyDeferral, verifyDeferralActions, verifyDeferralClear, verifyDeferralError, verifyDeferralSuccess };
